import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3933f5c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "body" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"ball\" data-v-3933f5c0><div class=\"circle\" style=\"--clr:#04fc43;\" data-v-3933f5c0></div><div class=\"circle\" style=\"--clr:#fee800;\" data-v-3933f5c0></div><div class=\"circle\" style=\"--clr:#ff2972;\" data-v-3933f5c0></div><div class=\"circle\" style=\"--clr:#03a0f4;\" data-v-3933f5c0></div></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}